import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mixApplyPage');

    return {
        ACRES_PER_TANK: t('acresPerTank'),
        APP_TANK: t('appTank'),
        APPLICATION_CONTEXT: t('applicationContext'),
        APPLICATOR_LICENSE: t('applicatorLicense'),
        APPLICATOR_NAME: t('applicatorName'),
        AUTO_FILL: t('autoFill'),
        BATCHES: t('batches'),
        CALCULATIONS: t('calculations'),
        CARRIER_INSUFFICIENT: t('carrierInsufficient'),
        CARRIER_RATE: t('carrierRate'),
        CARRIER_TYPE: t('carrierType'),
        COMPLIANCE_REPORT_BUTTON: t('complianceReportButton'),
        CONFIGURATION: t('configuration'),
        COUNTY: t('county'),
        CROP: t('crop'),
        CUSTOMER: t('customer'),
        CUSTOMER_ADDRESS: t('customerAddress'),
        DATE: t('date'),
        DICAMBA_OVERLAY: t('dicambaOverlay'),
        EDIT_MIX_DEFINITION: t('editMixDefinition'),
        EMPTY_RECIPE: t('emptyRecipe'),
        ERROR_LOADING_RECIPE: t('errorLoadingRecipe'),
        FAA_NUMBER: t('faaNumber'),
        FIELD: t('field'),
        FILLS_PER_BATCH: t('fillsPerBatch'),
        GUST: t('gust'),
        HUMIDITY: t('humidity'),
        LICENSE_VALID: t('licenseValid'),
        LOADING_RECIPE: t('loadingRecipe'),
        MIX_TANK: t('mixTank'),
        ORG_DEFAULTS: t('orgDefaults'),
        PARTIAL_LAST_TANK: t('partialLastTank'),
        PRODUCT_AMOUNTS: t('productAmounts'),
        PRODUCT_HEADER: t('productHeader'),
        PRODUCT_RATE_LABEL: t('productRateLabel'),
        PRODUCT_VOLUME: t('productVolume'),
        READY: t('ready'),
        RECIPE: t('recipe'),
        STATE_COMPLIANCE: t('stateCompliance'),
        STATUS: t('status'),
        TARGET_PEST: t('targetPest'),
        TEMPERATURE: t('temperature'),
        TITLE: t('title'),
        TOTAL_ACRES: t('totalAcres'),
        TOTAL_APP_FILLS: t('totalAppFills'),
        TOTAL_SPRAY_VOLUME: t('totalSprayVolume'),
        UNIT_GAL: t('unitGal'),
        UNIT_OZ: t('unitOz'),
        US_STATE_PREFIX: t('usStatePrefix'),
        WATER_VOLUME: t('waterVolume'),
        WEATHER: t('weather'),
        WEATHER_INFO: t('weatherInfo'),
        WEATHER_ISSUE: t('weatherIssue'),
        WEATHER_VALIDATION: t('weatherValidation'),
        WEATHER_VALIDATION_ORG_DEFAULTS: t('weatherValidationOrgDefaults'),
        WIND_DIRECTION: t('windDirection'),
        WIND_SPEED: t('windSpeed'),
        licenseDeadline: (state: string): string => t('licenseDeadline', { state }),
        partialTankWarning: (gallons: string): string => t('partialTankWarning', { gallons }),
        perTankHeader: (unit: string): string => t('perTankHeader', { unit }),
        productLicenseBlock: (product: string, state: string): string =>
            t('productLicenseBlock', { product, state }),
        stateComplianceFor: (state: string): string => t('stateComplianceFor', { state }),
        totalHeader: (unit: string): string => t('totalHeader', { unit })
    };
};

export default useTranslation;
